import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const FolderOffIcon = (props: SvgIconProps) => (
  <SvgIcon
    width={24}
    height={24}
    viewBox="0 -960 960 960"
    fill="#0000008a"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m871-202-71-71v-367H434l-80-80-80-80h114l80 80h332q33 0 56.5 23.5T880-640v400q0 11-2 20.5t-7 17.5ZM819-28 687-160H160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800l80 80h-80v480h447L28-820l56-56L876-84l-57 56ZM368-480Zm209-17Z" />
  </SvgIcon>
);

export default FolderOffIcon;
